import React from "react"
import Snackbar from "@material-ui/core/Snackbar"
import MuiAlert from "@material-ui/lab/Alert"

const Alert = props =>  <MuiAlert elevation={6} variant="filled" {...props} />

const Notification = props => {
  const handleClose = e => props.onClose()
  
  return (
    props.message !== undefined
    ?
      <Snackbar open={props.message !== undefined} onClose={handleClose}>
        <Alert onClose={handleClose} severity={props.severity}>
          { props.message }
        </Alert>
      </Snackbar>
    :
      null
  )
}

export default Notification
